<span *ngIf="control && control.errors && error" class="field-validation-valid text-danger">{{ error }}</span>